import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useDebounce from '../../hooks/useDebounce';

/**
 * Debounced search input for news queries.
 * Clears search on Escape key. Shows clear button when active.
 *
 * @param {{ onSearch: Function }} props
 */
const SearchBar = ({ onSearch }) => {
  const [query, setQuery] = useState('');
  const debouncedQuery = useDebounce(query, 300);

  useEffect(() => {
    onSearch(debouncedQuery);
  }, [debouncedQuery, onSearch]);

  /** Handle Escape key to clear search. */
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setQuery('');
    }
  };

  return (
    <form className="d-flex align-items-center" role="search" onSubmit={(e) => e.preventDefault()}>
      <div className="qs-search-wrapper">
        <svg className="qs-search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          className="qs-search-input"
          type="search"
          placeholder="Search..."
          aria-label="Search news"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        {query && (
          <button
            className="qs-search-clear"
            type="button"
            onClick={() => setQuery('')}
            aria-label="Clear search"
          >
            &#x2715;
          </button>
        )}
      </div>
    </form>
  );
};

SearchBar.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

SearchBar.displayName = 'SearchBar';

export default SearchBar;
